import atosRich from './atosRich';

export default atosRich;
